import { getColor } from 'basic-components';
import { ActionService, PERIOD_TYPE, tsDataRangesObject, tsKeysTypes, tsLastTypesObject, tsOrder } from 'dashboard-services';
import { globalActions } from 'primary-components';

import { CurvesUtils, LocalStorageUtils, TimeSeriesUtils } from 'utils';

import { MetadataLabel } from 'primary/TsSettings';

// series actions are not dependent on old TimeSeries actions or components
export default (() => {

  const defaultState = {
    range: tsDataRangesObject.last,
    lastTypeAmount: "1",
    lastType: tsLastTypesObject.value,
    
    fromSelected: undefined,
    from: undefined,
    
    toSelected: undefined,
    to: undefined,

    symbolSize: undefined,
    csvHeaders: CurvesUtils.DEFAULT_CSV_HEADERS,
    dateFormat: TimeSeriesUtils.DAILY_DATE_FORMAT,
    timeZone: undefined,
    periodType: PERIOD_TYPE.MONTH,
    contractSort: tsOrder.ASC,
    isRelative: "false",
    fillBlanks: ""
  }
  
  const ON_CHANGE = 'ON_CHANGE_SETTINGS_CURVES'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const CLEAR = 'CLEAR_LIST_SETTINGS_CURVES'
  const clear = ActionService.makeActionCreator(CLEAR)

  const saveDefaultSettings = () => (_, getState) => {
    // eslint-disable-next-line no-unused-vars
    const itemsToSave = getState().curvesState.settingsState
    LocalStorageUtils.setCurveDefaultSettings(itemsToSave)
  }

  const clearDefaultSettings = () => dispatch => {
    // eslint-disable-next-line no-unused-vars
    const itemsToSave = defaultState
    LocalStorageUtils.setCurveDefaultSettings(itemsToSave)
    dispatch(clear())
    dispatch(globalActions.getMessageStore()).success("Default settings has been restored.")
  }

  const getMetadataFilter = curve => ({
    [CurvesUtils.ROOT]: [curve.root],
    [CurvesUtils.PRODUCT]: [curve.product]
  })

  const getSelect = response => (response?.items || []).filter(item => item.type !== tsKeysTypes.SYMBOL).map(item => ({ 
    value: item.name, 
    label: <MetadataLabel name={item.name}/>,
    color: getColor("grey-dark"),
    type: `${item.type}_KEY`
  }))

  return {
    onChange,
    ON_CHANGE,
    CLEAR,
    clear,
    saveDefaultSettings,
    clearDefaultSettings,
    defaultState,
    getMetadataFilter,
    getSelect
  }
})()